import { getResolvedAppLang } from './cookie';

export function initI18n() {
	wpcore.direct_t = direct_t;
}

function direct_t(translations) {
	const lang = getResolvedAppLang();
	const def =
		(typeof wpcore !== 'undefined' && wpcore.defaultAppLang) || 'en';
	return translations[lang] ?? translations[def] ?? translations['en'];
}
